module.exports = {"audiences":["newUsers"],"autoTrack":true,"experimentAllocation":0.1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"audienceSettings":{"startDate":"2018-10-10"},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/guidedTour.json
// module id = v0VT
// module chunks = 1